module.exports = "<chart [options]=\"options\" (load)=\"saveInstance($event.context)\" ><chart>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/column-chart/column-chart.component.html
// module id = ../../../../../src/app/shared/components/graphs/column-chart/column-chart.component.html
// module chunks = main